export enum WalletTransactionType {
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    TRANSFER_OUT = "TRANSFER_OUT",
    TRANSFER_IN = "TRANSFER_IN",
    REVERSAL = "REVERSAL",
}

export enum WalletTransactionStatus {
    COMPLETED = "COMPLETED",
    REVERSED = "REVERSED",
}

export class WalletAccountBalanceView {
    sublimeAccountId!: number;
    accountNumber: string | null = null;
    balanceCents!: number;

    constructor(init?: Partial<WalletAccountBalanceView>) {
        Object.assign(this, init);
    }
}

export class WalletView {
    id!: number;
    companyId!: number;
    balanceCents!: number;
    accountsCount!: number;
    overdraftAllowed!: boolean;
    accounts: Array<WalletAccountBalanceView> = [];

    constructor(init?: Partial<WalletView>) {
        Object.assign(this, init);
    }
}

export class WalletTransactionView {
    id!: number;
    type!: WalletTransactionType;
    status!: WalletTransactionStatus;
    amountCents!: number;
    date!: string;
    sublimeAccountId!: number;
    clientAccountId: number | null = null;
    paymentId: number | null = null;
    paymentNomination: string | null = null;
    description: string | null = null;
    labelIds: Array<number> = [];
    relatedTransactionId: number | null = null;

    constructor(init?: Partial<WalletTransactionView>) {
        Object.assign(this, init);
    }
}

export class DepositPayload {
    clientAccountId!: number;
    sublimeAccountId!: number;
    amountCents!: number;
    date!: string;
    description: string | null = null;

    constructor(init?: Partial<DepositPayload>) {
        Object.assign(this, init);
    }
}

export class WithdrawPayload {
    sublimeAccountId!: number;
    amountCents!: number;
    date!: string;
    description: string | null = null;

    constructor(init?: Partial<WithdrawPayload>) {
        Object.assign(this, init);
    }
}

export class TransferPayload {
    fromAccountId!: number;
    toAccountId!: number;
    amountCents!: number;
    date!: string;
    description: string | null = null;

    constructor(init?: Partial<TransferPayload>) {
        Object.assign(this, init);
    }
}

export class ReversePayload {
    description: string | null = null;
    date: string | null = null;

    constructor(init?: Partial<ReversePayload>) {
        Object.assign(this, init);
    }
}
